import { render, staticRenderFns } from "./LoyaltyProgramDetails.vue?vue&type=template&id=cf72362e&scoped=true"
import script from "./LoyaltyProgramDetails.vue?vue&type=script&lang=js"
export * from "./LoyaltyProgramDetails.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyProgramDetails.vue?vue&type=style&index=0&id=cf72362e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf72362e",
  null
  
)

export default component.exports